import { LanguageCode } from 'i18n/internationalization.types';
import { BasePagingResponse, BaseResponse } from 'models/_base';
import { UsageType } from './Common';

export interface CustomTemplateLocale {
  uid?: string;
  subject?: string;
  content: string;
}

export interface CustomTemplateAssignedTrigger {
  uid: string;
  name: string;
}

export enum MessagingType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export type CustomTemplateLocales = Partial<
  Record<LanguageCode, CustomTemplateLocale>
>;

export interface CustomTemplate {
  uid: string;
  name: string;
  agencyUid: string;
  mainRecipient: string;
  usageType: UsageType;
  messagingType: MessagingType;
  assignedTriggers: CustomTemplateAssignedTrigger[];
  autoTranslate?: boolean;
}

export interface CustomTemplateWithLocales extends CustomTemplate {
  locales: CustomTemplateLocales;
}

export interface GetCustomTemplatesResponse
  extends BaseResponse,
    BasePagingResponse {
  templates: CustomTemplate[];
}

export interface CustomTemplateCreatePayload
  extends Pick<
    CustomTemplateWithLocales,
    'name' | 'locales' | 'messagingType'
  > {
  autoTranslate?: boolean;
}

export interface CustomTemplateUpdatePayload {
  customTemplateUid: string;
  name?: string;
  locales?: CustomTemplateLocales;
  autoTranslate?: boolean;
}

export interface TranslateCustomTemplateResponse {
  templateUid: string;
  localeUid: string;
  sourceLanguage: LanguageCode;
  targetLanguage: LanguageCode;
  translatedSubject: string;
  translatedContent: string;
}
